import {Relative} from "react-admin-base-bootstrap";

export default function LanguageSpan({ value }) {
    if (!value)
        return <>-</>;

    return <>
        { value.icon && <Relative>
            <img src={value.icon.access_url} className="me-2" style={{ width: '24px', height: '24px' }} alt={value.name} />
        </Relative> }
        {(value.language_code || '-').toUpperCase()}
    </>;
}
